import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductLandingPagesAugmentedReality } from '@/features/public-pages/AugmentedReality'

export const Route = createFileRoute('/_event/p/realidade-aumentada')({
  staticData: {
    isPublic: true
  },
  component: DigitalProductLandingPagesAugmentedRealityPage
})

function DigitalProductLandingPagesAugmentedRealityPage() {
  return <DigitalProductLandingPagesAugmentedReality />
}
